module.exports = __webpack_public_path__ + "static/pets-277e727a3bc7681de533762fe63b4652.png";